module.exports = __webpack_public_path__ + "img/ripley-2023-nov.f68a8073.png";